import { Divider, Stack, DialogContent, DialogActions, Dialog, Button } from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { get } from 'lodash';
import { useDispatch } from 'react-redux';
import { LoadingButton } from '@mui/lab';

import { Strings } from '@app/constants';
import { Header } from '@app/sections/header';
import { useRequestState } from '@app/hooks';
import { FormProvider, RHFTextField } from '@app/components';
import { addDesignationSchema } from '../validators';
import { IDesignation, IAddDesignationSchema } from '../types';
import { addDesignation } from '../slice';
import { selectAddDesignationState } from '../selectors';

interface Props {
  open: boolean;
  onClose: VoidFunction;
  row?: IDesignation;
}

const AddDesignation = ({ open, onClose, row }: Props) => {
  const dispatch = useDispatch();

  const methods = useForm<IAddDesignationSchema>({
    resolver: yupResolver(addDesignationSchema) as any,
    defaultValues: {
      name: get(row, 'name', ''),
      desc: get(row, 'desc', ''),
    },
  });

  const onSubmit = (form: IAddDesignationSchema) => {
    const id = row?.id ?? 0;
    dispatch(addDesignation({ ...form, id }));
  };
  const { loading: saveDesignation } = useRequestState({
    stateSelector: selectAddDesignationState,
    onSuccess: onClose,
    successMessageShown: true,
    errorShown: true,
  });
  return (
    <>
      <FormProvider methods={methods}>
        <Dialog open={open} fullWidth>
          <Header
            variant="dialog"
            title={row ? Strings.designation.updateDesignation : Strings.designation.addDesignation}
            onClose={onClose}
          />
          <Divider />
          <DialogContent>
            <Stack spacing={2} my={2}>
              <RHFTextField
                name="name"
                required
                label={Strings.field.name}
                fullWidth
                variant="outlined"
                multiline
              />

              <RHFTextField
                name="desc"
                label={Strings.field.description}
                fullWidth
                variant="outlined"
                multiline
                minRows={3}
              />
            </Stack>
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button variant="outlined" color="inherit" onClick={onClose}>
              {Strings.button.cancel}
            </Button>
            <LoadingButton
              type="submit"
              variant="contained"
              loading={saveDesignation}
              onClick={methods.handleSubmit(onSubmit)}
            >
              {Strings.button.save}
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export { AddDesignation };
